import React, { useEffect, useState } from 'react';
import { api } from '../../api';

function StatCard({ label, value, sub, color = 'blue' }) {
  const colors = {
    blue:   'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300',
    green:  'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300',
    amber:  'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300',
    slate:  'bg-slate-50 dark:bg-slate-800 text-slate-700 dark:text-slate-300',
  };
  return (
    <div className={`min-w-0 rounded-lg border border-slate-200 dark:border-slate-700 p-4 sm:p-5 ${colors[color]}`}>
      <p className="text-xs font-medium uppercase tracking-wider opacity-70 mb-1">{label}</p>
      <p className="text-xl sm:text-3xl font-bold break-words">{value ?? '—'}</p>
      {sub && <p className="text-xs mt-1 opacity-60">{sub}</p>}
    </div>
  );
}

export default function Overview() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats').then(setStats).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center h-48">
      <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <StatCard label="Accounts"            value={stats?.total_accounts}       color="slate" />
        <StatCard label="Active Subscriptions" value={stats?.active_subscriptions} color="green" />
        <StatCard label="Pending Requests"     value={stats?.pending_requests}     color="amber"
          sub={stats?.pending_requests > 0 ? 'Awaiting approval' : 'None pending'} />
        <StatCard label="Total Users"  value={stats?.total_users}  color="blue" />
        <StatCard label="Total Deals"  value={stats?.total_deals}  color="slate" />
        <StatCard label="Total Bids"   value={stats?.total_bids}   color="slate" />
      </div>
    </div>
  );
}
